import { Typography } from 'antd';
import styled from 'styled-components';

export const LabelText = styled(Typography.Text)`
  word-break: break-word;
`;
